import { render, staticRenderFns } from "./sideBar.vue?vue&type=template&id=349c8ccb&scoped=true"
import script from "./sideBar.vue?vue&type=script&lang=js"
export * from "./sideBar.vue?vue&type=script&lang=js"
import style0 from "./sideBar.vue?vue&type=style&index=0&id=349c8ccb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349c8ccb",
  null
  
)

export default component.exports